<template>
<div>
    <b-table 
        v-if="departures.length > 0"
        small
        sticky-header
        selectable
        primary-key='index'
        select-mode="single"
        :items="departures" 
        :fields="fields"
        :busy="loading"
        tbody-tr-class="departure-row" 
        ref="departureTable" 
        id='departures'
        class="departures">

        <template v-slot:cell(estimateTime)="data">
            <div v-if="data.item.passingCanceled"><b-icon icon="exclamation-triangle-fill" scale='1.2' style="margin-right: 6px"/>{{ $t('timetables.canceled') }}</div>
            <div v-else> {{ getTime(data.item.estimateTime) }}</div>
        </template>

        <template v-slot:cell(destination)="data">
            <div>{{ data.item.destination }}</div>
             <div v-if="getVia(data.item)" class='via'>{{ getVia(data.item) }}</div>
        </template>

        <template v-slot:cell(stop)="data">
            <div v-if="data.item.stopSms">
                <div>{{ data.item.stop }}</div>
                <div class='via'><span>{{ data.item.stopSms }}</span>  <span v-if="data.item.platform">{{ data.item.platform }}</span></div>
            </div>
            <div v-else>
                 <div>{{ data.item.stop }} <span v-if="data.item.platform" class='via'>{{ data.item.platform }}</span></div>
            </div>
        </template>

        <template v-slot:cell(vehicle)="data">
            <VehicleBrief :label="data.item.vehicle"></VehicleBrief>
        </template>
    </b-table> 
    <span v-if="!loading && departures.length == 0" class="info note">{{ $t('timetables.no_departures') }}</span>
    <RequestInfo :loader="loading" />
</div>
</template>

<script>
import VehicleBrief from '@/components/Realtime/VehicleBrief'

export default {
    components: {VehicleBrief},
    props: {
        item: { default: null },
        count: { default: 10 }
    },
    data() {
        return {
            departures: [],
            departureUpdater: null,
            loading: false,
            date: null,
            dates: []
        }
    },
    computed: {
      
        fields(){
            var cols = []; 
            cols.push( { key: "passingTime", label: this.$t("timetables.labels.passing_time"), formatter: 'getTime', tdClass: 'time' } );
            cols.push( { key: "estimateTime", label: this.$t("timetables.labels.estimate_time"),  tdClass: 'rt'} );
            cols.push( { key: "lineLabel", label: this.$t("timetables.labels.line"), tdClass: 'line' } );
            cols.push( { key: "destination", label: this.$t("timetables.labels.destination"),  tdClass: 'dest'} );

            cols.push(  { key: "stop", label: this.$t("timetables.labels.stop"), tdClass: 'stop'} );

            // privilege / setting to enable/disable ? 
            cols.push(  { key: "vehicle", label: this.$t("timetables.labels.vehicle"), thClass: 'vehicle' , tdClass: 'vehicle' } );

            return cols;
        }

    },
    watch: {
        item(){
            this.departures = [];
            this.updateDepartures();
        }

    },
    created(){
    
        this.updateDepartures();
    },
    beforeDestroy(){
        clearTimeout(this.departureUpdater);
    },
    methods: {
        updateDepartures(){
            
            clearTimeout(this.departureUpdater);

            if( !this.item ) {
                return
            }
            
            this.loading = true;
            
          
            const params = { 
                params: {
                    "id" : this.item.id,
                    "count": this.count
                }
            }

            //console.log(params.params.start + "/" +  params.params.end);

            this.$traveller_http.get('/traveller/restui/content/timetableview/departures', params )
            .then(response => {
                this.departures = response.data;
                
                // show vehicle column only if vehicle information is available
                let vehicleInformationFound = this.departures.find(d => d.vehicle ) != null;
                if(vehicleInformationFound){
                    let elems = document.querySelectorAll("#departures .vehicle");
                    elems.forEach( e => { e.style.display ="table-cell" } );
                }
            })
            .catch( () => {})
            .finally(() => {
                this.loading = false;
                this.departureUpdater = setTimeout(this.updateDepartures, 30000);               
            });
        },
        getTime(value){
            if(!value)
                return ""
            const date = new Date(value);
            const hours = date.getHours();
            let minutes = date.getMinutes();
            let seconds = date.getSeconds();
            if(minutes < 10) minutes = "0" + minutes;
           
           let time = hours + ":" + minutes;
           if(seconds > 0) {
                if(seconds < 10) seconds = "0" + seconds;
                time += ":" + seconds;
         }

            return time;
        },
        getVia(item){
            let via = "";
            
            if(item.intermediateDestinations){
                 for (let v of item.intermediateDestinations) {
                     via += v + " "; 
                 }
            }

            via = via.trim();

            const maxLength = 25;
            if(via.length > maxLength)
                via = via.slice(0, maxLength-1) + '...'

            return via;
        }
    }
}

</script>

